/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';
import Grid from '@material-ui/core/Grid';
import {
    object, string, arrayOf, shape,
} from 'prop-types';

const PageHeading = ({
    classes, headingTitle, listItem,
}) => {
    const seed = useUIDSeed();
    return (
        <>
            <Grid container className={classes.container}>
                <div className={classes.listBlock}>
                    <ul className={classes.list}>
                        {listItem.map((list)  => (
                            <li className={classes.listItem} key={seed(list)}> <Link className={classes.anchorTag} to={list.href}>{list.item}</Link><span className={classes.span} /></li>
                        ))}
                    </ul>

                </div>
                <Grid item xs={9} className={classes.headingBlock}>
                    <div>
                        <h1 className={classes.headingTitle}>{headingTitle}</h1>
                        <div className={classes.line} />
                    </div>

                </Grid>
            </Grid>;
        </>
    );
};

PageHeading.propTypes = {
    classes: object.isRequired,
    headingTitle: string.isRequired,
    listItem: arrayOf(
        shape({
            href: string.isRequired,
            item: string.isRequired,

        }),
    ).isRequired,
};

export default PageHeading;
